import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { U2bValidators } from '@shared/validators/validators';
import { SignaturePad } from 'angular2-signaturepad';
import { TenantApiService } from '@modules/bcm/@shared/services';
import { Subject } from 'rxjs';
import { downloadFile } from '@shared/functions/download-file';
import { TranslationService } from '@core/translation/translation.service';

@Component({
    selector: 'form-widget-avv',
    templateUrl: './form-widget-avv.component.html',
    styleUrls: ['./form-widget-avv.component.scss'],
    standalone: false
})
export class FormWidgetAvvComponent implements AfterViewInit, OnInit, OnDestroy {

    private _unsubscribeAll = new Subject<any>();

    @ViewChild(SignaturePad) signaturePad: SignaturePad;

    @Input()
    parentFormGroup: UntypedFormGroup;

    @Output()
    loadingChange = new EventEmitter<boolean>();

    avvFormGroup: UntypedFormGroup;

    isSigned: boolean;

    signaturePadOptions: object = { // passed through to szimek/signature_pad constructor
        // minWidth: 5,
        canvasWidth: 500 * Math.max(window.devicePixelRatio || 1, 1),
        canvasHeight: 150 * Math.max(window.devicePixelRatio || 1, 1)
    };

    constructor(private _formBuilder: UntypedFormBuilder,
                private _tenantApiService: TenantApiService) {
        this.avvFormGroup = this._formBuilder.group({
            accepted: [false, [U2bValidators.requiredTrue('common.validationMsg.acceptProcessingAgreementRequired')]],
            signature: [null, [/*U2bValidators.required('Keine digitale Signatur eingezeichnet')*/]],
            signatureText: [null, [U2bValidators.required(TranslationService.translate('common.validationMsg.signatureRequired'))]],
        });
    }

    ngOnInit(): void {
        setTimeout(() => {
            this.parentFormGroup.addControl('avv', this.avvFormGroup);
        });
    }

    ngOnDestroy(): void {
        this.parentFormGroup.removeControl('avv');
        this._unsubscribeAll.next(undefined);
        this._unsubscribeAll.complete();
    }

    ngAfterViewInit(): void {
        // this.signaturePad.clear();
    }

    drawComplete(): void {
        this.isSigned = true;
        this.saveSignature();
    }

    drawStart(): void {
        // ...
    }

    saveSignature(): void {
        // .toDataURL(); // save image as PNG
        // .toDataURL("image/jpeg"); // save image as JPEG
        // .toDataURL("image/svg+xml"); // save image as SVG
        this.avvFormGroup.get('signature').setValue(this.signaturePad.toDataURL());
        this.avvFormGroup.get('signature').updateValueAndValidity();
    }

    openAvvTemplate(event: Event): void {
        event.preventDefault();
        this.loadingChange.emit(true);
        this._tenantApiService.getAvvTemplatePdf()
            .subscribe(blob => {
                downloadFile(blob, 'AVV-Vorlage', 'pdf', 'application/pdf');
            })
            .add(() => this.loadingChange.emit(false));
    }

    clearSignature(): void {
        this.isSigned = false;
        this.signaturePad.clear();
        this.avvFormGroup.get('signature').reset();
        this.avvFormGroup.get('signature').updateValueAndValidity();
    }
}
